import { render, staticRenderFns } from "./longshort.component.vue?vue&type=template&id=12d77ad0&scoped=true"
import script from "./longshort.component.vue?vue&type=script&lang=js"
export * from "./longshort.component.vue?vue&type=script&lang=js"
import style0 from "./longshort.component.vue?vue&type=style&index=0&id=12d77ad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d77ad0",
  null
  
)

export default component.exports